import { createStore } from "vuex"
import axios from 'axios' 
import sha256 from 'crypto-js/sha256' 
import Base64 from 'crypto-js/enc-base64' 

async function f_getswapdata (self, state, pswline) 
{
            if (typeof pswline == "string")
                pswline = parseInt(pswline) ;

            let swap = state.swaps.find ( (swap) => swap.pswline == pswline )
            if (! swap) return 0 ;
            if (swap.state != "on") 
                return 0 ; 


            if (swap.inrequest) {
                // console.log ( pswline +  " inrequest") ;
                return swap ;
            }

            let lastinterval = state.controller.interval - 1000 ;
            if (lastinterval < 1000)
                lastinterval = 1000 ; 

            let lastreq = state.controller.interval + 1 ;
            if (swap.lastrequest) 
                lastreq = +new Date - swap.lastrequest ;

            if ( lastreq < lastinterval ) 
                return swap ;


            let addr = self.state.controller.addr ;
            const url1 = addr.protocol + "//" + addr.addr +
                    "/prosw/route/combine/1?swapid=" + pswline.toString() ;

            swap.inrequest = 1 ;
            var response = null ;
            // console.log ("request " + url1) ;
            try {
                 response = await axios.get (url1, {
                 timeout: 5000,
                 headers: {'Pswtoken': self.getters.pswtoken,
                          'Access-Control-Allow-Origin': '*' }
                 }) ;
             }
             catch (error) 
             { 
                 console.log (error) ; 
                 swap["speedo"] = null 
                 swap.lastrequest = +new Date ;
                 swap.inrequest = 0;
                 return error ;
             }

             // console.log ("after axios call " + pswline.toString()) ;
             swap.lastrequest = +new Date ;
             swap.inrequest = 0;
             let newdata = JSON.parse(JSON.stringify(response.data));
             if (newdata.RC == "91") {
                if (state.curpage != 0) {
                         state.curpage = 0 ; 
                         return alert ( newdata.RDESC ) ;
                }
             }
             let olddata = swap["sdata"]
             if (newdata.RC == "00" && olddata && olddata.RC == "00") {
               let apr = newdata["approval"] 
               let n_apr = 0 
               let version = "" 
               for ( let obj of Object.entries(apr)) {
                 if (obj[0] == "version")
                   version = obj[1]  ;
                 else
                   n_apr += obj[1].pid.length ;
                }
               let toutdata = {} ;
               let keys = Object.keys(newdata.txdata) ;
               keys.forEach ( (k) => {
                 if ( ! (k in  olddata.txdata) )
                    toutdata[k] = 0 ;
                 else
                 if (newdata.txdata[k] > olddata.txdata[k])
                    toutdata[k] = newdata.txdata[k] - olddata.txdata[k] ;
                 else
                    toutdata[k] = 0 ;
                 })

               let period_insec = newdata.txdata["c127"] - olddata.txdata["c127"] ;

               let rcodedata = {} ;
               keys = Object.keys(newdata.txdata.rcode) ;
               keys.forEach ( (k) => {
                    if (typeof olddata.txdata.rcode[k] == "undefined")
                      rcodedata[k] = 0 ;
                    else
                    if (newdata.txdata.rcode[k] > olddata.txdata.rcode[k])
                      rcodedata[k] = newdata.txdata.rcode[k] - olddata.txdata.rcode[k] ;
                    else
                      rcodedata[k] = 0 ;
                    })
                        
               swap["speedo"] = 
                      { "txdata"  : toutdata, 
                        "period"  : period_insec,
                        "rcode"   : rcodedata,
                        "totconn" : newdata.logaddr.length,
                        "totapr"  : n_apr,
                        "version" : version,
                        "totmsg"  : newdata.txdata.totinc + newdata.txdata.totout 
                    }
              }
              else
                 swap["speedo"] = null 

              swap["sdata"] = newdata ;
              swap["seq"]++ ;
              return pswline ;
}

export default createStore({
	state: {
        adminlvl : 0,
        pswtoken : "",
		email: "",
        curpage : 0,
        active_swap : 0,
        controller: { 'addr' : null,
                      'state' : "pending",
                      'local' : 1,
                      'interval' : 10000,
                      'pswline' : 9000 },
        swaps : [],   /* obj -> pswline, name, state, sdata, speedo, seq */
        swapmaps : null,
        swapcontrol : 0,
        screens : null,
        version : '11.5',
        usermgmt : null,
        curmappage : 0, 
        inrequest : 0 ,
        rootel    : null,          // root el
        forcechgpwd : 0             // force password change
	},
	getters: {
        pswtoken (state) {
           return state.pswtoken ;
        },
        forcechgpwd(state) {
            return state.forcechgpwd ;
        },
        screens (state) {
           return state.screens ;
        },
        swapcontrol(state) {
            return state.swapcontrol ;
        },
        active_swap(state) {
           return state.active_swap;
        },
        controllerid(state) {
           return state.controller.pswline.toString() ;
        },
        controller_url(state) {
           let addr = state.controller.addr ;
           return addr.protocol + "//" + addr.addr ;
        },
        version(state) {
            return state.version ;
        },
        curpage(state) {
            return state.curpage ;
        },
        adminlvl (state) {
            return state.adminlvl ;
        },
        usermgmt(state) {
            return state.usermgmt;
        },
        menuaccess(state) {
            var userroles = state.usermgmt.userroles ;
            for (let i in userroles) {
              if ( userroles[i].id == state.adminlvl)
                  return userroles[i].access ;
            }
            return 0 ;
        },
        userlogin(state) {
            return state.email ;
        },
        isdone(state) {
            return state.controller.state == "done" ;
        },
        getmaps(state) {
            return state.swapmaps ;
        },
        interval(state) {
            return state.controller.interval ;
        },
        totseq (state) {
            let tot = 0 ;
            for (let i = 0 ; i < state.swaps.length ; i++) 
                tot += state.swaps[i].seq  ;
            return tot ;
        },
        getswap_byid : (state) => (pswline) => {
            if (typeof pswline == "string")
                pswline = parseInt(pswline)
            let swap = state.swaps.find ( (swap) => swap.pswline == pswline )
            return swap ;
        },
        getswap_data : (state) => (pswline, data) => {
            if (typeof pswline == "string")
                pswline = parseInt(pswline)
            let swap = state.swaps.find ( (swap) => swap.pswline == pswline )
            if (! swap) return 0 ;
            if (! swap.sdata) return 0 ;
            if (! swap.sdata.txdata) return 0 ;
            return swap.sdata.txdata[data] ;
        },
        getswap_byname : (state) => (name) => {
            return state.swaps.find ( (swap) => swap.name == name )
        },
        wait1sec() 
        { console.log("wait1sec") ; },
        async swapmaps(state) {
            if ( state.controller.state != "done") 
                await setTimeout(state.getters.wait1sec,1000) ;

            if ( state.controller.state != "done") 
                return null  ;

            if ( ! state.swapmap ) {
              let addr = this.state.controller.addr ;
              let req = addr.protocol + "//" + addr.addr +
                               "/prosw/CFG/get?" +
                                "&filename=swap/swapmap.json" ;
              try {
                let response = await axios.get (req) ;
                if (typeof response.data != "object" ) {
                    let json = JSON.parse(response.data) ;
                    state.swapmaps = json ;
                }
                else
                   state.swapmaps = JSON.parse(JSON.stringify(response.data)) 
                return state.swapmaps ;
              }
              catch (err) {
                console.log (err) ;
                return null ;
              }
            }
            else
                return state.swapmaps ;
        },
        getswap_list(state) 
        {
            if (! state.swaps) return [] ;
            let res = []
            for (let i in state.swaps) {
                if (state.swaps[i].name) {
                    let obj = {}
                    obj.name = state.swaps[i].name ;
                    obj.state = state.swaps[i].state;
                    obj.pswline = state.swaps[i].pswline;
                    res.push(obj) ;
                }
            }
            return res;
        }
	},
	mutations: {
		login(state, logindata) {
            let hashDigest = sha256( logindata.user + logindata.password) ;
            let textDigest = Base64.stringify(hashDigest) ;

            let addr = this.state.controller.addr ;
            let req = addr.protocol + "//" + addr.addr +
                        "/prosw/login"  ;
                       
            let formData = new FormData();
            formData.append('user', logindata.user) ;
            formData.append('password', textDigest) ;

            try {
              axios.post (req, formData,
                  { headers: {
                    'Content-Type': 'multipart/form-data' 
                    }
                 }).then (response => {
                    localStorage.setItem("email", logindata.user) ;
                    state.email = logindata.user ;
                    let res = response.data ;
                    if (! res || res.RC != "00") {
                        state.curpage = 0 ;
                        if (res) logindata.comp.writemsg (res.RDESC) ;
                        else logindata.comp.writemsg ("LOGIN FAILED") ;
                        return ;
                    }
                    state.adminlvl = res.RESULT.admin ;
                    state.pswtoken = res.RESULT.pswtoken ;
                    state.curpage = 1;
                    state.active_swap = 0 ;
                    if (state.adminlvl == 200) {
                        state.adminlvl = 0 ;
                        state.curpage = 0;
                        state.forcechgpwd = 1 ; 
                    }
                    if (state.adminlvl == 201) {
                        state.adminlvl = 0 ;
                        state.curpage = 0;
                        state.forcechgpwd = 2 ; 
                    }

                    if (state.controller.pswline)
                        state.active_swap = state.controller.pswline ;
                  }
                 ) ;

            }
            catch(err) {
                console.log (err) ;
                logindata.comp.errormsg = "Server send BAD response" ;
                return null ;
            }
        },
		changepwd(state, logindata) {
            let hashDigest = sha256( logindata.user + logindata.oldpasswd) ;
            let oldpasswd = Base64.stringify(hashDigest) ;

            hashDigest = sha256( logindata.user + logindata.newpasswd) ;
            let newpasswd = Base64.stringify(hashDigest) ;

            let addr = this.state.controller.addr ;
            let req = addr.protocol + "//" + addr.addr +
                        "/prosw/chgpasswd"  ;
                       
            let formData = new FormData();
            formData.append('user', logindata.user) ;
            formData.append('oldpasswd', oldpasswd) ;
            formData.append('newpasswd', newpasswd) ;

            try {
              axios.post (req, formData,
                  { headers: {
                    'Content-Type': 'multipart/form-data', 
                    'Pswtoken': this.getters.pswtoken 
                    }
                 }).then (response => {
                    let res = response.data ;
                    if (! res ) 
                        return alert ("change passwd failed") ;
                    else
                    if (res.RC != "00")
                        return alert ("ERROR:" + res.RDESC) ;
                    if (state.forcechgpwd >= 1) {
                       state.forcechgpwd = 0 ;    
                       state.adminlvl = res.RESULT.admin ;
                    }
                    alert ("changed password success!") ;
                  }).catch (error => 
                    { alert ( "ERROR:" + error) }
                  );
            }
            catch(err) {
                console.log (err) ;
                alert ("BAD reply") ;
                return null ;
            }
        },
		logout(state) {
			state.email = "" ;
			localStorage.removeItem('email') ;
            state.curpage = 0 ;

            let addr = this.state.controller.addr ;
            let req = addr.protocol + "//" + addr.addr + "/prosw/logout" ;
            axios.get (req, {
                    timeout: 5000,
                    headers: {'Pswtoken': this.getters.pswtoken }
            }).then ( response => { console.log (response.data) ; } )
		},
        set_rootel(state, newroot) {
			state.rootel = newroot;
        },
        changemap(state, newpage) {
			state.curmappage = newpage ;
        },
        changemapid(state, newid) {
            let maps = state.swapmaps ;
            newid = parseInt(newid); 
            for (let i = 0 ; i < maps.length ; i++) 
                if (maps[i].id == newid) {
                    state.curmappage = i ;
                    break ;
                }
        },
        changepage(state, newpage) {
			state.curpage = newpage ;
        },
        changeswap(state, newswap) {
			state.active_swap = newswap;
        },
        incswapseq(state, swapline) {
            let swap = state.swaps.find ( (swap) => swap.pswline == swapline) ;
            if (swap) swap["seq"]++ ;
        },
		initializeStore(state) {
			if (localStorage.getItem('email')) {
				state.email = localStorage.getItem('email');
			}
		},
        async getswapdata(state) {
          if ( state.controller.state != "done")
                return ;
          for (let swap of state.swaps) {
             await f_getswapdata ( this, state, swap.pswline) ;
          }
        },
        async reqswapdata(state, pswline) {
            return f_getswapdata(this, state, pswline) ;
        },
        async setup(state, controller) {
            const url1 = new URL(window.location.toString()) ;

            try {
              let ctlobj = controller ;
              let newctl = { rules : ctlobj.rules,
                               addr  : "", 
                               protocol : url1.protocol, 
                               iprule : 0 
                           } ;

              for ( let i in newctl.rules ) {
                    let r = newctl.rules[i] ; // value pair (string, idx)
                    if (url1.hostname.startsWith(r[0]) || 
                        url1.hostname.startsWith("www." + r[0])) {
                       newctl.iprule = parseInt(r[1]) ;
                       newctl.addr = ctlobj.addrlist[ newctl.iprule ] ;
                       if (newctl.addr == '*') newctl.addr = url1.host ;
                       break ;
                    }
                }

              state.controller.addr = newctl ;
              state.controller.interval = ctlobj.interval ;
              state.controller.local = ctlobj.local ;
              if ( state.controller.interval < 1000)
                 state.controller.interval = 1000 ;
              state.controller.state = "done";
              let addr = this.state.controller.addr ;
              let req = addr.protocol + "//" + addr.addr +
                               "/prosw/CFG/get?" +
                                "&filename=swap/configuration" ;
              let response = await axios.get (req, { 
                timeout: 5000,
                headers: {'Pswtoken': this.getters.pswtoken }
              }) ;
              let json ;

              if (typeof response.data.RESULT != "object" ) 
                  json = JSON.parse(response.data.RESULT) ;
              else 
                  json = JSON.parse(JSON.stringify(response.data.RESULT)) ;

              state.swaps = json.swaplist ;
              state.screens = json.screens ;
              state.version = json.version;
              state.controller.pswline = json.pswline ;
              state.usermgmt = json.usermgmt ;
              if (json.swapcontrol)
                state.swapcontrol = json.swapcontrol ;

              for (let swap of state.swaps) {
                  swap["seq"] = 0 ;
              }
              this.commit ("get_swapmaps") ;
              // this.commit( "getswapdata" ) ;
            } catch (error) {
              console.log (error) ;
              state.controller.state = "error";
            }
        },
        async get_swapmaps(state) {
              let addr = this.state.controller.addr ;
              let req = addr.protocol + "//" + addr.addr +
                               "/prosw/CFG/get?" +
                                "&filename=swap/swapmap.json" ;
              try {
                let response = await axios.get (req, {
                    timeout: 5000,
                    headers: {'Pswtoken': this.getters.pswtoken }
                }) ;
                if (typeof response.data != "object" ) {
                    let json = JSON.parse(response.data) ;
                    state.swapmaps = json;
                }
                else {
                   let resobj = JSON.parse(JSON.stringify(response.data)) 
                   state.swapmaps = resobj
                }
                let maps = state.swapmaps ;
                for (let i = 0 ; i < maps.length ; i++) {
                    if (! maps[i].id) maps[i].id = i + 1;       // assign id from 1
                }
              }
              catch (err) {
                console.log (err) ;
                return null ;
              }
        },
	},
	action: {
	},
	modules: {
	}
})


// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
